// translate.js
import en from '../translations/en.json';
import tr from '../translations/tr.json';
import de from '../translations/de.json';
import { cds } from './cds.js';

class Translation {
  constructor() {
    if (!Translation.instance) {
      this.translations = { en: en, tr: tr, de: de };
      this.currentLang = 'tr'; // Varsayılan dil
      Translation.instance = this; // Singleton örneği
    }
    return Translation.instance;
  }

  setLanguage(lang) {
    if (this.translations[lang] || lang == 'tr') {
      this.currentLang = lang;
    } else {
      console.warn(`Dil bulunamadı: ${lang}`);
    }
  }

  changeLanguage(lang) {
    cds('user/change-language', {
      method: 'POST',
      body: { lang: lang },
    }).then(() => {
      window.location.reload();
    });
  }

  getLanguage() {
    return this.currentLang;
  }

  translate(key, replaces = {}) {
    let translation = this.translations[this.currentLang]?.[key] || key;
    for (const [key, value] of Object.entries(replaces)) {
      translation = translation.replace(`{${key}}`, value);
    }
    return translation;
  }
}

// Singleton örneğini dışa aktar
const translationInstance = new Translation();
export const trans = (key, replaces = {}) => translationInstance.translate(key, replaces);
export const setLanguage = (lang) => translationInstance.setLanguage(lang);
export const changeLanguage = (lang) => translationInstance.changeLanguage(lang);